import React from "react";

const Profile = () => {
  const inputStyles =
    "text-sm placeholder:text-sm placeholder:text-l_gray py-2 px-4 border-b border-dr_gray focus:border-b focus:border-hl focus:outline-none";
  const handleUpdate = (e) => {
    e.preventDefault();
  };
  return (
    <div>
      <form action="submit" onSubmit={handleUpdate}>
        <div className="">
          <label htmlFor="name">
            Name:
            <input
              className={inputStyles}
              value=""
              name="name"
              placeholder="Enter name"
            />
          </label>
          <label htmlFor="name">
            Last name:
            <input
              className={inputStyles}
              value=""
              name="name"
              placeholder="Enter last name"
            />
          </label>
        </div>
        <div className="">
        <label htmlFor="specialization">
            Specialization:
            <input
              className={inputStyles}
              value=""
              name="specialization"
              placeholder="Enter specialization"
            />
          </label>
        </div>
        <div className="">
          <label htmlFor="name">
            What should we call you:
            <input
              className={inputStyles}
              value=""
              name="by name"
              placeholder="Enter by name"
            />
          </label>
          <label htmlFor="phone">
            Phone:
            <input
              className={inputStyles}
              value=""
              name="phone"
              placeholder="Enter phone number"
            />
          </label>
        </div>
        <div className="">
        <label htmlFor="bio">
            bio:
            <input
              className={inputStyles}
              value=""
              name="bio"
              placeholder="Enter by name"
            />
          </label>
          <label htmlFor="about">
            About me:
            <textarea
              className={inputStyles}
              value=""
              name="about"
              placeholder="Enter about me"
            />
          </label>
        </div>
        <div className="mt-[2rem]">
          <p className="">Gender:</p>
          <div className="flex w-full mt-4 gap-8">
            <div className="flex items-center gap-2 cursor-poiner">
              <label htmlFor="male">Male</label>
              <input type="radio" id="male" name="gender" value="male" />
            </div>
            <div className="flex items-center gap-2 cursor-poiner">
              <label htmlFor="female">female</label>
              <input type="radio" id="gender" name="gender" value="female" />
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="bg-h5 py-2 px-4 mt-10 hover:bg-hl cursor-pointer duration-200 rounded-md"
        >
          Update
        </button>
      </form>
    </div>
  );
};

export default Profile;
